import React, { useEffect, useReducer, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { usePdfPageClientQuery } from '@queries/client';
import { PresentationProvider } from '@context/presentation';
import { CurrentSlide } from '@components';
import { salesRepReducer, initialRepState } from '@actions/reducers';
import { SLIDE_IDS, BROWSER_STORAGE_KEYS } from '@constants';
import { setBrowserStorageItem } from '@utils/browserStorage';

const PdfPresentationContainer = styled.div`
    display: flex; 
    flex-direction: column;
    justify-content: center;
    align-items: center;   
    width: 100vw;
    height: auto;
    margin: auto;
`;

const PdfSinglePageContainer = styled.div`
    width: 100%;
    height: 562px;
    margin: 7.25rem;
    padding: 0 1rem;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.01);
`;

// To-do: how can we make this page available to the PDF function, but protected against anyone viewing? 

export const RenderToPdfPage = () => {
  const slideRef = React.useRef(null);
  const { leadId, slideSequence } = useParams();
  const { search } = useLocation();
  const { i18n } = useTranslation();
  const [unauthorized, setUnauthorized] = useState(false);
  const [slideState, dispatch] = useReducer(salesRepReducer, initialRepState);
  const { isLoading, error, data: client } = usePdfPageClientQuery({ leadId }, i18n, setUnauthorized);
  const slideList = slideSequence.split('-').map(id => parseInt(id));
  
  useEffect(() => {
    const selectedTerms = new URLSearchParams(search);
    const { termOptions, summary }= SLIDE_IDS;
    const { selectedTermKey } = BROWSER_STORAGE_KEYS;
  
    const termOptionsTerm = parseInt(selectedTerms.get(termOptions));
    const summaryTerm = parseInt(selectedTerms.get(summary));

    setBrowserStorageItem(`${selectedTermKey}_${termOptions}`, termOptionsTerm);
    setBrowserStorageItem(`${selectedTermKey}_${summary}`, summaryTerm);
  }, []);
  
  if (error) return <div>Something failed: {error.reponse?.data ?? error.message}</div>;

  if (isLoading) return <div>Loading...</div>;

  if (unauthorized) return <div>This page can only be viewed during an active presentation.</div>;

  return (
      <PresentationProvider client={client}>
        <PdfPresentationContainer>
            {
              slideList.map(item => {
                return <PdfSinglePageContainer key={item}>
                            <CurrentSlide
                                dispatch={dispatch}
                                slideState={slideState}
                                slideId={item}
                                ref={slideRef}
                                showScript={false}
                                pdfStyleActive={true}/>
                        </PdfSinglePageContainer>;
                })
            }
        </PdfPresentationContainer>
      </PresentationProvider>
  );
};

export default RenderToPdfPage;
